export default {
	multiTask: {
		app: "Програма",
		upgrade: "Оновлення",
		processPid: "pid процесу",
		working: "Працюючі",
		completed: "Завершені",
		completedWithError: "Завершені з помилкою",
		infoAboutThisTaskYouCanSeeInStatus: "Інформацію з цих завдань можна подивитися в статусі завдань, відфільтрувавши за коментарем",
		currentPackageComment: "Коментар поточної пачки",
		task: "Завдання",
		fileSelect: "Вибір файлу",
		youRun: "Ви запустили",
		tasks: "завдань",
		successfully: "Успішно",
		moreDetails: "Детальніше",
		clearResults: "Очистити результати",
		clear: "Очистити",
		start: "Запуск",
		noAppsSelectedError: "Не вибрано жодної програми",
		enterStartMessage: "Введіть повідомлення для запуску",
		tooLongOperation: "Довгий час виконання завдань, припиняється виконання запитів",
		noSuchTasks: "Запущені завдання не знайдені",
		presetElementNotFound: "Один з елементів пресету не знайдений в дереві",
		enter: "Ввести",
		cancellation: "Скасувати",
		busyTasks: "Зайняті завдання"
	},
	runTask: {
		fileSelect: "Вибір файлу",
		result: "Результат",
		forMoreDetailsAboutValueLookConsole: "Для додаткової інформації про повернуті значення подивіться консоль",
		cancel: "Скасувати",
		exit: "Вихід",
		server: "Сервер",
		app: "Програма",
		autoLoading: "Авто-завантаження",
		administration: "Адміністрування",
		appliedTasks: "Прикладні завдання",
		itsMistake: "Це помилка",
		shortMessage: "коротке повідомлення",
		plsRefreshPage: "Поновiть, будь ласка, сторінку"
	}
}